(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/pay/to-api-wagers.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/pay/to-api-wagers.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const currencyAsJupiterString = svs.utils.format.CurrencyAsJupiterString;
const productMapping = svs.numbergames.productMapping;
const bagTypes = svs.numbergames.pay_numbergames.data.bagTypes;
const prolongation = svs.numbergames.game_model.utils.prolongation;
const boardName = {
  KENO: 'kenoBoards',
  LOTTO: 'lottoBoards',
  EUROJACKPOT: 'extNumberBoards',
  VIKINGLOTTO: 'extNumberBoards',
  JOKER: 'jokerBoards'
};
function boardProps(board) {
  const allNumbers = board.numbers.concat(board.numbersExtra || []);
  if (allNumbers.every(n => n.manual)) return [];
  if (allNumbers.every(n => !n.manual)) return ['QUICKPICK'];
  return ['PARTIALQP'];
}
function toApiBoard(board) {
  var _board$numbersExtra;
  const b = {
    rowPriceMulti: 1,
    boardProps: boardProps(board),
    systemType: board.isSystem ? ['MSYS'] : ['SROW'],
    systemNum: 0,
    numSelections: (_board$numbersExtra = board.numbersExtra) !== null && _board$numbersExtra !== void 0 && _board$numbersExtra.length ? "".concat(board.numbers.length, "+").concat(board.numbersExtra.length) : board.numbers.length
  };
  switch (board.productId) {
    case productMapping.CONSTANTS.LOTTO:
      b.boardData = board.numbers.map(n => n.number);
      b.participation = board.rowPriceMulti === 2 ? 'L1L2' : 'L1';
      break;
    case productMapping.CONSTANTS.KENO:
      b.boardData = board.numbers.map(n => n.number);
      b.participation = (board.hasKungKeno ? 'KK' : 'K') + board.level;
      b.rowPriceMulti = board.rowPriceMulti;
      break;
    case productMapping.CONSTANTS.JOKER:
      b.boardData = board.numbers.map(n => n.number);
      b.participation = 0;
      break;
    default:
      b.boardData1 = board.numbers.map(n => n.number);
      b.boardData2 = board.numbersExtra.map(n => n.number);
      b.participation = 0;
  }
  return b;
}
function betAmounts(game) {
  let betAmount = game.boards.reduce((price, board) => price + board.rowPrice * board.rowCount, 0) * game.drawCount;
  let betAmount2 = 0;
  switch (game.productId) {
    case productMapping.CONSTANTS.LOTTO:
      if (game.rowPriceMulti > 1) {
        betAmount2 = betAmount;
      }
      break;
    case productMapping.CONSTANTS.KENO:
      betAmount = game.boards.reduce((price, board) => price + board.rowPrice * game.rowPriceMulti * board.rowCount, 0) * game.drawCount;
      betAmount2 = game.boards.reduce((price, board) => price + board.rowPrice * game.rowPriceMulti * board.rowCount * board.hasKungKeno, 0) * game.drawCount;
      break;
    default:
  }
  return {
    betAmountSalesGroup1: currencyAsJupiterString(betAmount),
    betAmountSalesGroup2: currencyAsJupiterString(betAmount2)
  };
}
function getBetProperties(_ref) {
  let game = _ref.game,
    productItsId = _ref.productItsId;
  const betProperties = [];
  const jokerBetProperties = [];
  if (game.prolongedBet) {
    const isBetProlonged = prolongation.isProlongedBet({
      itsId: productItsId,
      rowPriceMulti: game.rowPriceMulti,
      boards: game.boards,
      prolongedBet: game.prolongedBet
    });
    if (isBetProlonged) {
      betProperties.push('PROLONGATION');
    }
    if (game.hasJoker) {
      const isJokerProlonged = prolongation.isProlongedJoker({
        jokerRow: game.jokerRow,
        jokerPrice: game.jokerPrice,
        jokerItsId: productMapping.getJokerProductId(productItsId),
        prolongedBet: game.prolongedBet
      });
      if (isJokerProlonged) {
        jokerBetProperties.push('PROLONGATION');
      }
    }
  }
  return {
    betProperties,
    jokerBetProperties
  };
}
function toApiBets(_ref2) {
  let game = _ref2.game,
    productItsId = _ref2.productItsId;
  const numDraws = parseInt(game.drawCount, 10);
  const _getBetProperties = getBetProperties({
      game,
      productItsId
    }),
    betProperties = _getBetProperties.betProperties,
    jokerBetProperties = _getBetProperties.jokerBetProperties;
  const bets = [_objectSpread(_objectSpread({
    productId: productItsId,
    numDraws,
    drawNum: svs.numbergames.draws.drawsApi.drawNumber(productItsId),
    betProperties
  }, betAmounts(game)), {}, {
    rowPriceMulti: 1,
    [boardName[game.productId]]: game.boards.map(board => toApiBoard(_objectSpread(_objectSpread({}, board), {}, {
      rowPriceMulti: game.rowPriceMulti
    })))
  })];
  if (game.hasJoker) {
    bets.push({
      productId: productMapping.getJokerProductId(productItsId),
      numDraws,
      drawNum: svs.numbergames.draws.drawsApi.jokerDrawNumber(productItsId),
      betProperties: jokerBetProperties,
      betAmountSalesGroup1: currencyAsJupiterString(game.jokerPrice * numDraws),
      betAmountSalesGroup2: '0,00',
      rowPriceMulti: game.jokerPrice / svs.numbergames.rules.joker.getRowPrice(),
      jokerBoards: [toApiBoard({
        productId: productMapping.CONSTANTS.JOKER,
        numbers: game.jokerRow
      })]
    });
  }
  return bets;
}
function toApiWager(options) {
  var _bagTypes$find$bagTyp, _bagTypes$find;
  const bagType = (_bagTypes$find$bagTyp = (_bagTypes$find = bagTypes.find(bag => bag.productItsId === options.productItsId && bag.size === options.game.selectedPackage)) === null || _bagTypes$find === void 0 ? void 0 : _bagTypes$find.bagType) !== null && _bagTypes$find$bagTyp !== void 0 ? _bagTypes$find$bagTyp : 0;
  return {
    bagType,
    bets: toApiBets(options)
  };
}
function toApiWagers(game) {
  if (!productMapping.isProductFamily(game.productId)) {
    game = _objectSpread(_objectSpread({}, game), {}, {
      selectedDays: [productMapping.getProductItsId(game.productId)]
    });
  }
  return game.selectedDays.map(productItsId => toApiWager({
    game,
    productItsId
  }));
}
svs.numbergames.game.pay.toApiWagers = toApiWagers;

 })(window);